import removeHostFromUrl from '@devhacker/shared/utils/removeHostFromUrl';

const hostsToClean = [
  'lifehacker.ru',
  'dev.lifehacker.ru',
  'pre.lifehacker.ru',
  'test.lifehacker.ru',
];

export function removeLifehackerFromUrl(url: string) {
  try {
    const { hostname } = new URL(url);
    if (hostsToClean.includes(hostname)) return removeHostFromUrl(url);
  } catch {
    /* empty */
  }

  return url;
}
